export default {
  "client.p.searchname":"名前検索",
  "client.partner.name":"取引先名",
  "client.partner.alias":"取引先略称",
  "client.partner.classification":"取引先区分",
  "client.partner.code":"取引先コード",
  "client.modal.title":"取引先作成・編集",
  "client.modal.subtitle":"取引先基本情報",
  "client.partner.p.name":"取引先名を入力してください",
  "client.partner.kana":"取引先カナ",
  "client.partner.p.kana":"取引先名カナを入力してください",
  "client.partner.p.alias":"例) EGL",
  "client.partner.p.code":"例) E001",
  "client.text.choose":"選択してください",
  "client.partner.deptincharge":"担当部署",
  "client.partner.p.deptincharge":"例) 営業部",
  "client.partner.personincharge":"担当者役職",
  "client.partner.p.personincharge":"例) 課長",
  "client.partner.person.name":"担当者氏名",
  "client.partner.p.person.name.male":"例) 映画　太郎",
  "client.partner.person.title":"敬称",
  "client.partner.p.person.title":"例) 御中／様",
  "client.partner.p.perfecture":"例) 東京都",
  "client.partner.responsibleperson":"自社担当者名",
  "client.partner.p.person.name.female":"例) 映画　花子",
  "client.text.needed":"が必要",
  "client.text.cityarea":"市区町村",
  "client.partner.classification.name":"取引先区分名",
  "client.partner.subsidy.subject":"補助科目",
  "client.partner.subsidy.journal":"（仕訳連携用）",
  "client.text.partner":"取引先",
  "client.deposit.accounting": "勘定科目（仕訳連携用）",
  "client.modal.group.title":"取引先区分作成・編集",
  "client.partner.p.xyz":"例) XYZ",
  "client.partner.depositadd":"預金先作成・追加",
  "client.partner.deposit.basicinfo":"預金先基本情報",
  "client.deposit.name":"預金先名",
  "client.deposit.code":"預金先コード",
  "client.deposit.institute":"金融機関",
  "client.deposit.branch":"支店名",
  "client.deposit.accounttype":"口座種類",
  "client.deposit.accountnumber":"口座番号",
  "client.deposit.accountholder":"口座名義",
  "client.deposit.p.name":"例) 株式会社〇〇　〇〇口座",
  "client.deposit.p.institute":"例) 〇〇銀行",
  "client.deposit.institutecode":"金融機関コード",
  "client.deposit.p.branch":"例) 〇〇支店",
  "client.deposit.branchcode":"支店コード",
  "client.deposit.p.accounttype":"例) 普通口座",
  "client.deposit.p.accountnumber":"例) 0123456",
  "client.deposit.p.accountholder":"例) エイガランド（カ",
  "client.deposit.targetcinema":"利用対象劇場",
  "client.deposit.account":"勘定科目",
  "client.deposit.accountNumber.ex":"例) 1520",
  "client.text.isneeded":"が必要です",
  "client.invoiceSetting": "売掛金 / 買掛金の設定",

};